// @flow

import type {Locale} from 'docs/data';
import {isDefaultLocale, sanitizeLocale as sanitize} from 'docs/util'; // Alias makes no-unsanitized linter work

export const loadMessagesForLocale = async (locale: Locale) => {
  let messages;

  // For the default locale (that is, English), we want to use our reference
  // strings instead of depending on an English language bundle.
  if (isDefaultLocale(locale)) {
    return {};
  }

  try {
    // $FlowExpectedError Flow doesn't understand Webpack's dynamic imports.
    messages = await import(
      /* webpackChunkName: "i18n-[request]-chunk" */
      `docs/intl/dist/shell/${sanitize(locale.code)}.json`
    );
  } catch (err) {
    messages = {};
  }

  return messages;
};
